import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  PortalFactsService,
} from './portal.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [PortalFactsService]
})
export class PortalFactsModule {}
